import { createContext } from 'react';

export interface DialogCloseContextValue {
  requestClose: () => void;
}

export const DialogCloseContext = createContext<DialogCloseContextValue | null>(null);
